import * as React from 'react';
import { AnalyticsProvider, Check, Grid, GridColumn, Separator, useCurrentBreakPoint } from 'telia-front-react';
import TvChannelComparisonChannels from './TvChannelComparisonChannels';
const TvChannelComparisonChannelsGrid = (props) => {
    const { channelInclusions, selectedPackage, showAllChannels, setShowAllChannels } = props;
    const currentBreak = useCurrentBreakPoint();
    const visibleChannelsCount = channelInclusions.filter((channel) => channel.includedInProducts.includes(selectedPackage)).length;
    const isXs = currentBreak === 'xs';
    return (React.createElement(Grid, { horizontalGutter: "medium", verticalGutter: "small", borderWeight: "thin" },
        React.createElement(GridColumn, { width: ['xs-12'], className: "text-left" },
            React.createElement("p", { className: "h4 text-bold" },
                props.translate('tvChannelComparison.totalChannels.label'),
                React.createElement("span", { className: "text-light" },
                    "(",
                    visibleChannelsCount,
                    ")")),
            React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
            React.createElement(AnalyticsProvider, { group: "TV channels" },
                React.createElement(Check, { labelText: `${props.translate('tvChannelComparison.showAllChannels')}`, id: "tvChannelComparison-show-all-channels", value: "on", checked: showAllChannels, onChange: (checked) => setShowAllChannels(checked) })),
            React.createElement(Separator, { spacing: "xxsmall", color: "invisible" })),
        React.createElement(GridColumn, { width: ['xs-6', 'sm-3'], "aria-hidden": true, border: ['bottom-xs'] }),
        React.createElement(GridColumn, { width: ['xs-6', 'sm-3'], "aria-hidden": true, border: ['bottom-xs'] }),
        !isXs && React.createElement(GridColumn, { width: ['sm-3'], "aria-hidden": true, border: ['bottom-xs'] }),
        !isXs && React.createElement(GridColumn, { width: ['sm-3'], "aria-hidden": true, border: ['bottom-xs'] }),
        React.createElement(GridColumn, null,
            React.createElement(TvChannelComparisonChannels, { columns: isXs ? 2 : 4, channelInclusions: props.channelInclusions, translate: props.translate, selectedPackage: selectedPackage, showAllChannels: showAllChannels }))));
};
export default TvChannelComparisonChannelsGrid;
